import {
  CLOSE_LA,
  LOGIN_FROM_LA,
  SHOW_LA
} from 'store/ducks/loginAssistant/types';

export const onCloseLoginAssistantClick = () => ({ type: CLOSE_LA });
export const onLoginFromLoginAssistantClick = redirectPath => ({ type: LOGIN_FROM_LA, redirectPath });
export const onShowLoginAssistant = () => ({ type: SHOW_LA });
